import api from '../../api'

export const persist = async (tires, homepageDomain, locationId) => {
	let axleTirePref
	for (const tire of tires) {
		if (tire.isCreate) {
			if (!axleTirePref) {
				let resp = await api.service('localAccounts').find({
					query: {
						id: {
							$eq: locationId
						}
					}
				})
				axleTirePref = resp.data[0].axleTirePreferenceId

				if (!axleTirePref) {
					const axleTireResponse = await api.service('axleTirePreferences').create({
						name: homepageDomain.profileName, 
					})
					axleTirePref = axleTireResponse.id
					await api.service('localAccounts').patch(locationId, {
						axleTirePreferenceId: axleTireResponse.id
					})
				}
			}
			await api.service('axleTireDetails').create({
				preferencesId: axleTirePref,
				priority: tire.priority,
				isRetread: tire.tireType,
				brandId: tire.tireBrand,
				treadId: tire.tread,
				loadRangeId: tire.loadRange,
				tireApplicationId: tire.application,
				comments: tire.comments,
				sizeId: tire.tireSize,
				axleTypeId: tire.axleType,
				isErs: true
			})
		} else if (tire.isDelete) {
			await api.service('axleTireDetails').remove(null, {
				query: {
					id: {
						$eq: tire.id
					}
				}
			})
		} else if (tire.isUpdate) {
			await api.service('axleTireDetails').patch(tire.id, {
				priority: tire.priority,
				isRetread: tire.tireType,
				brandId: tire.tireBrand,
				treadId: tire.tread,
				loadRangeId: tire.loadRange,
				tireApplicationId: tire.application,
				comments: tire.comments,
				sizeId: tire.tireSize,
				axleTypeId: tire.axleType
			})
		}
	}

	
}


// WEBPACK FOOTER //
// ./src/database/lbb/tirePreference.js